import React, { useEffect, useState } from "react";
import image1 from "./k.webp";
import image2 from "./kk.webp";
import image3 from "./kkk.webp";
import image4 from "./kkkk.jpg";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../Admin/Config/Config";
import { useNavigate } from "react-router-dom";

export default function Grid() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slides, setSlides] = useState([]);
  const [cards, setCards] = useState([]);
  const navigate = useNavigate();

  // Fetch banner images from Firebase
  const fetchBannerData = async () => {
    try {
      const ref = collection(db, "banner");
      const q = query(ref, orderBy("order", "asc"));
      const querySnapshot = await getDocs(q);
      const bannerSlides = [];
      querySnapshot.forEach((doc) => {
        bannerSlides.push({ id: doc.id, ...doc.data() });
      });
      setSlides(bannerSlides);
    } catch (error) {
      console.error("Error fetching banner data:", error);
      // Fallback images in case of error
      setSlides([
        { img_url: image1 },
        { img_url: image2 },
        { img_url: image3 }
      ]);
    }
  };

  // Fetch card data from Firebase
  const fetchCardData = async () => {
    try {
      const ref = collection(db, "home_cards");
      const q = query(ref, orderBy("order", "asc"));
      const querySnapshot = await getDocs(q);
      const cards = [];
      querySnapshot.forEach((doc) => {
        cards.push({ id: doc.id, ...doc.data() });
      });
      setCards(cards);
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };

  useEffect(() => {
    fetchBannerData();
    fetchCardData();
  }, []);

  // Auto-advance carousel
  useEffect(() => {
    if (slides.length <= 1) return; // Don't auto-advance if there's only one slide

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const navigationPage = (category) => {
    navigate(`/search-items?query=${encodeURIComponent(category)}`);
  };

  return (
    <div className="bg-gray-50 p-4 sm:p-6 font-sans mobile-scroll">
      {cards.length === 4 && slides.length > 0 && (
        <div className="max-w-7xl mx-auto">
          {/* Section Heading */}
          <div className="mb-4 lg:mb-6">
            <h2 className="text-lg sm:text-xl lg:text-2xl font-normal text-black text-left">
              Discover Our Premium Collection
            </h2>
          </div>

          {/* Main Carousel Banner - Modernized */}
          <div className="mb-8 lg:mb-12">
            <div
              className="group relative rounded-2xl sm:rounded-3xl lg:rounded-[2rem] overflow-hidden transition-all duration-700 md:hover:scale-[1.02] md:hover:shadow-2xl md:hover:shadow-slate-900/20 h-56 xs:h-64 sm:h-80 md:h-96 lg:h-80 xl:h-96 touch-pan-y"
              style={{
                boxShadow:
                  "0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.1)",
              }}
            >
              {/* Background Image with Enhanced Effects */}
              <div className="relative w-full h-full overflow-hidden">
                <img
                  src={slides[currentSlide]?.img_url}
                  alt={`Slide ${currentSlide + 1}`}
                  className="w-full h-full object-cover transition-all duration-1000 ease-out group-hover:scale-110"
                />

                {/* Gradient Overlays */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-black/20 transition-opacity duration-500"></div>
                <div className="absolute inset-0 bg-gradient-to-r from-slate-900/20 via-transparent to-slate-900/20 opacity-0 md:group-hover:opacity-100 transition-opacity duration-700"></div>

                {/* Animated Background Particles */}
                <div className="absolute inset-0 opacity-30">
                  <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-white/60 rounded-full animate-pulse"></div>
                  <div className="absolute top-3/4 right-1/3 w-1 h-1 bg-white/40 rounded-full animate-ping"></div>
                  <div className="absolute bottom-1/3 left-2/3 w-1.5 h-1.5 bg-white/50 rounded-full animate-bounce"></div>
                </div>
              </div>

              {/* Enhanced Navigation Arrows */}
              <button
                onClick={prevSlide}
                className="absolute left-3 sm:left-6 lg:left-8 top-1/2 transform -translate-y-1/2 z-30 group/btn bg-white/10 md:hover:bg-white/20 backdrop-blur-xl rounded-full p-2 sm:p-3 lg:p-4 transition-all duration-300 md:hover:scale-110 md:hover:-translate-x-1 border border-white/20 md:hover:border-white/40 shadow-2xl touch-manipulation"
              >
                <svg
                  className="w-5 h-5 sm:w-6 sm:h-6 lg:w-7 lg:h-7 text-white group-hover/btn:text-slate-100 transition-colors duration-200"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.5}
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </button>

              <button
                onClick={nextSlide}
                className="absolute right-3 sm:right-6 lg:right-8 top-1/2 transform -translate-y-1/2 z-30 group/btn bg-white/10 md:hover:bg-white/20 backdrop-blur-xl rounded-full p-2 sm:p-3 lg:p-4 transition-all duration-300 md:hover:scale-110 md:hover:translate-x-1 border border-white/20 md:hover:border-white/40 shadow-2xl touch-manipulation"
              >
                <svg
                  className="w-5 h-5 sm:w-6 sm:h-6 lg:w-7 lg:h-7 text-white group-hover/btn:text-slate-100 transition-colors duration-200"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.5}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>

              {/* Modern Carousel Indicators */}
              <div className="absolute bottom-4 sm:bottom-6 lg:bottom-8 left-1/2 transform -translate-x-1/2 z-20">
                <div className="flex items-center space-x-2 sm:space-x-3 bg-black/20 backdrop-blur-xl rounded-full px-3 sm:px-4 py-2 sm:py-3 border border-white/20">
                  {slides.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => goToSlide(index)}
                      className={`relative transition-all duration-500 md:hover:scale-110 touch-manipulation ${currentSlide === index
                        ? "w-6 sm:w-7 lg:w-8 h-2 sm:h-2 lg:h-2.5 bg-white rounded-full shadow-lg"
                        : "w-2 sm:w-2 lg:w-2.5 h-2 sm:h-2 lg:h-2.5 bg-white/50 md:hover:bg-white/70 rounded-full"
                        }`}
                    >
                      {currentSlide === index && (
                        <div className="absolute inset-0 bg-gradient-to-r from-white to-slate-200 rounded-full animate-pulse"></div>
                      )}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Categories Section Heading */}
          <div className="mb-6 lg:mb-8">
            <h2 className="text-lg sm:text-xl lg:text-2xl font-normal text-black text-left">
              Explore Our Product Range
            </h2>
          </div>

          {/* Product Categories Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2 sm:gap-3 touch-pan-y">
            {/* Food & Cone Dip Warmers - Geometric Modern Style */}
            <div
              className="group relative bg-gradient-to-br from-slate-50 to-gray-100 rounded-3xl overflow-hidden shadow-2xl md:hover:shadow-slate-300/50 transition-all duration-700 cursor-pointer border-2 border-slate-200 md:hover:border-slate-400 md:hover:-translate-y-3 md:hover:rotate-1 touch-manipulation"
              onClick={() => navigationPage(cards[0]?.category || "")}
            >
              {/* Geometric Background Pattern */}
              <div className="absolute inset-0 opacity-10">
                <div className="absolute top-4 right-4 w-16 h-16 bg-slate-400 rounded-full"></div>
                <div className="absolute bottom-6 left-6 w-12 h-12 bg-gray-400 rotate-45"></div>
                <div className="absolute top-1/2 left-1/4 w-8 h-8 bg-slate-300 rounded-full"></div>
              </div>
              <div className="relative z-10">
                <div className="h-40 sm:h-48 flex items-center justify-center relative md:group-hover:scale-105 transition-all duration-500 overflow-hidden rounded-2xl">
                  <img
                    src={cards[0]?.image || image1}
                    alt="Food & Cone Dip Warmers"
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black/20 md:group-hover:bg-black/30 transition-all duration-500"></div>
                </div>

                <div className="absolute top-2 left-2 sm:top-4 sm:left-4 bg-gradient-to-r from-red-500 via-red-600 to-red-700 text-white px-2 py-1 sm:px-4 sm:py-2 rounded-xl sm:rounded-2xl text-xs font-black shadow-2xl animate-pulse md:group-hover:animate-bounce">
                  {cards[0]?.tags?.[0] || "...Loading"}
                </div>
                <div className="absolute top-2 right-2 sm:top-4 sm:right-4 bg-slate-900 text-slate-100 px-2 py-1 sm:px-3 sm:py-1.5 rounded-full text-xs font-bold shadow-lg md:group-hover:bg-slate-700 transition-colors duration-300">
                  {cards[0]?.tags?.[1] || "...Loading"}
                </div>
                <div className="absolute bottom-2 left-2 sm:bottom-4 sm:left-4 bg-gradient-to-r from-slate-900 to-black text-white px-2 py-1 sm:px-3 sm:py-2 rounded-xl sm:rounded-2xl text-xs font-bold backdrop-blur-md border border-slate-200/30 shadow-2xl">
                  {cards[0]?.tags?.[2] || "...Loading"}
                </div>
              </div>

              <div className="p-4 sm:p-6 bg-white/80 backdrop-blur-sm border-t border-slate-200/50">
                <h3 className="font-black text-sm sm:text-lg mb-2 text-slate-900 md:group-hover:text-slate-700 transition-colors duration-300">
                  {cards[0]?.title || "Food & Cone Dip Warmers"}
                </h3>
                <p className="text-slate-700 text-xs sm:text-sm leading-relaxed font-medium">
                  {cards[0]?.subtitle || "...Loading"}
                </p>
              </div>
            </div>

            {/* Cafe & Baking Must-Haves - Neumorphism Style */}
            <div
              className="group relative bg-gradient-to-br from-slate-50 to-gray-50 rounded-[2rem] overflow-hidden transition-all duration-600 cursor-pointer md:hover:-translate-y-4 md:hover:rotate-2 touch-manipulation"
              style={{
                boxShadow: "20px 20px 40px #d1d5db, -20px -20px 40px #ffffff",
              }}
              onClick={() => navigationPage(cards[1]?.category || "")}
            >
              {/* Floating Elements */}
              {/* <div className="absolute inset-0 overflow-hidden">
                <div className="absolute -top-4 -right-4 w-20 h-20 bg-gradient-to-br from-slate-300 to-gray-300 rounded-full opacity-20 group-hover:scale-150 group-hover:opacity-30 transition-all duration-700"></div>
                <div className="absolute bottom-4 left-4 w-16 h-16 bg-gradient-to-br from-slate-400 to-gray-400 rounded-full opacity-15 group-hover:scale-125 transition-all duration-500"></div>
              </div> */}

              <div className="relative z-10">
                <div className="h-40 sm:h-48 flex items-center justify-center relative md:group-hover:scale-105 transition-all duration-500 overflow-hidden rounded-2xl">
                  <img
                    src={cards[1]?.image || image2}
                    alt="Cafe & Baking Must-Haves"
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black/20 md:group-hover:bg-black/30 transition-all duration-500"></div>
                </div>

                <div className="absolute top-2 left-2 sm:top-4 sm:left-4 bg-gradient-to-r from-red-500 via-red-600 to-red-700 text-white px-2 py-1 sm:px-4 sm:py-2 rounded-xl sm:rounded-2xl text-xs font-black shadow-2xl animate-pulse md:group-hover:animate-bounce">
                  {cards[1]?.tags?.[0] || "...Loading"}
                </div>
                <div className="absolute top-2 right-2 sm:top-4 sm:right-4 bg-gradient-to-r from-slate-800 to-slate-700 text-slate-100 px-2 py-1 sm:px-3 sm:py-1.5 rounded-xl sm:rounded-2xl text-xs font-bold shadow-xl">
                  {cards[1]?.tags?.[1] || "...Loading"}
                </div>
                <div className="absolute bottom-2 left-2 sm:bottom-4 sm:left-4 bg-gradient-to-r from-slate-900 to-black text-white px-2 py-1 sm:px-3 sm:py-2 rounded-xl sm:rounded-2xl text-xs font-bold backdrop-blur-md border border-slate-200/30 shadow-2xl">
                  {cards[1]?.tags?.[2] || "...Loading"}
                </div>
              </div>

              <div className="p-4 sm:p-6 bg-white/60 backdrop-blur-md border-t border-slate-200/50">
                <h3 className="font-black text-sm sm:text-lg mb-2 text-slate-900 md:group-hover:text-slate-600 transition-colors duration-300">
                  {cards[1]?.title || "Cafe & Baking Must-Haves"}
                </h3>
                <p className="text-slate-700 text-xs sm:text-sm leading-relaxed font-medium">
                  {cards[1]?.subtitle || "Simple Ingredients, Big Taste"}
                </p>
              </div>
            </div>

            {/* Catering & Tabletop Picks - Glassmorphism Style */}
            <div
              className="group relative bg-gradient-to-br from-slate-100/40 via-gray-100/40 to-slate-200/40 rounded-3xl overflow-hidden transition-all duration-700 cursor-pointer md:hover:-translate-y-5 md:hover:-rotate-1 backdrop-blur-xl border border-white/30 touch-manipulation"
              style={{
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.1), rgba(255,255,255,0.05))",
                backdropFilter: "blur(20px)",
                boxShadow:
                  "0 25px 50px rgba(71, 85, 105, 0.15), inset 0 1px 0 rgba(255,255,255,0.2)",
              }}
              onClick={() => navigationPage(cards[2]?.category || "")}
            >
              {/* Animated Background Orbs */}
              <div className="absolute inset-0">
                <div className="absolute top-0 left-0 w-32 h-32 bg-gradient-to-br from-slate-400/20 to-gray-400/20 rounded-full blur-2xl group-hover:scale-150 group-hover:translate-x-4 group-hover:translate-y-4 transition-all duration-1000"></div>
                <div className="absolute bottom-0 right-0 w-24 h-24 bg-gradient-to-br from-slate-500/20 to-gray-500/20 rounded-full blur-xl group-hover:scale-125 group-hover:-translate-x-2 group-hover:-translate-y-2 transition-all duration-700"></div>
              </div>

              <div className="relative z-10">
                <div className="h-40 sm:h-48 flex items-center justify-center relative md:group-hover:scale-105 transition-all duration-500 overflow-hidden rounded-2xl">
                  <img
                    src={cards[2]?.image || image3}
                    alt="Catering & Tabletop Picks"
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black/20 md:group-hover:bg-black/30 transition-all duration-500"></div>
                </div>

                <div className="absolute top-2 left-2 sm:top-4 sm:left-4 bg-gradient-to-r from-red-500 via-red-600 to-red-700 text-white px-2 py-1 sm:px-4 sm:py-2 rounded-xl sm:rounded-2xl text-xs font-black shadow-2xl backdrop-blur-md border border-white/40 animate-pulse md:group-hover:shadow-red-500/50">
                  {cards[2]?.tags?.[0] || "...Loading"}
                </div>
                <div className="absolute top-2 right-2 sm:top-4 sm:right-4 bg-white/20 backdrop-blur-md text-slate-900 px-2 py-1 sm:px-3 sm:py-1.5 rounded-xl sm:rounded-2xl text-xs font-bold shadow-xl border border-white/30">
                  {cards[2]?.tags?.[1] || "...Loading"}
                </div>
                <div className="absolute bottom-2 left-2 sm:bottom-4 sm:left-4 bg-black/30 backdrop-blur-xl text-white px-2 py-1 sm:px-3 sm:py-2 rounded-xl sm:rounded-2xl text-xs font-bold border border-white/20 shadow-2xl">
                  {cards[2]?.tags?.[2] || "...Loading"}
                </div>
              </div>

              <div className="p-4 sm:p-6 bg-white/10 backdrop-blur-md border-t border-white/20">
                <h3 className="font-black text-sm sm:text-lg mb-2 text-slate-900 md:group-hover:text-slate-700 transition-colors duration-300">
                  {cards[2]?.title || "Catering & Tabletop Picks"}
                </h3>
                <p className="text-slate-800 text-xs sm:text-sm leading-relaxed font-medium">
                  {cards[2]?.subtitle || "The Essential Element for Your Event"}
                </p>
              </div>
            </div>

            {/* Specialty Pastas - Gradient Mesh Style */}
            <div
              className="group relative overflow-hidden rounded-[2.5rem] transition-all duration-800 cursor-pointer md:hover:-translate-y-6 md:hover:rotate-3 touch-manipulation"
              style={{
                background:
                  "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 25%, #cbd5e1 50%, #94a3b8 75%, #64748b 100%)",
                boxShadow:
                  "0 30px 60px rgba(71, 85, 105, 0.3), 0 0 0 1px rgba(255,255,255,0.2)",
              }}
              onClick={() => navigationPage(cards[3]?.category || "")}
            >
              {/* Mesh Gradient Overlay */}
              <div
                className="absolute inset-0 opacity-60 group-hover:opacity-80 transition-opacity duration-500"
                style={{
                  background:
                    "radial-gradient(circle at 20% 80%, rgba(148, 163, 184, 0.8) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(100, 116, 139, 0.8) 0%, transparent 50%), radial-gradient(circle at 40% 40%, rgba(71, 85, 105, 0.6) 0%, transparent 50%)",
                }}
              ></div>

              {/* Animated Particles */}
              <div className="absolute inset-0">
                <div className="absolute top-6 right-8 w-3 h-3 bg-white/40 rounded-full animate-ping"></div>
                <div className="absolute bottom-8 left-6 w-2 h-2 bg-slate-200/60 rounded-full animate-pulse"></div>
                <div className="absolute top-1/2 right-1/4 w-4 h-4 bg-slate-300/50 rounded-full animate-bounce"></div>
              </div>

              <div className="relative z-10">
                <div className="h-40 sm:h-48 flex items-center justify-center relative md:group-hover:scale-105 transition-all duration-500 overflow-hidden rounded-2xl">
                  <img
                    src={cards[3]?.image || image4}
                    alt="Specialty Pastas"
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black/20 md:group-hover:bg-black/30 transition-all duration-500"></div>
                </div>

                <div className="absolute top-2 left-2 sm:top-4 sm:left-4 bg-gradient-to-r from-red-500 via-red-600 to-red-700 text-white px-2 py-1 sm:px-4 sm:py-2 rounded-xl sm:rounded-3xl text-xs font-black shadow-2xl animate-pulse md:group-hover:animate-none md:group-hover:scale-110 transition-all duration-300">
                  {cards[3]?.tags?.[0] || "...Loading"}
                </div>
                <div className="absolute top-2 right-2 sm:top-4 sm:right-4 bg-black/40 backdrop-blur-md text-slate-100 px-2 py-1 sm:px-3 sm:py-1.5 rounded-xl sm:rounded-2xl text-xs font-bold shadow-xl border border-slate-200/30">
                  {cards[3]?.tags?.[1] || "...Loading"}
                </div>
                <div className="absolute bottom-2 left-2 sm:bottom-4 sm:left-4 bg-gradient-to-r from-slate-900 to-black text-slate-100 px-2 py-1 sm:px-3 sm:py-2 rounded-xl sm:rounded-3xl text-xs font-bold backdrop-blur-md border border-slate-200/30 shadow-2xl">
                  {cards[3]?.tags?.[2] || "...Loading"}
                </div>
              </div>

              <div className="p-4 sm:p-6 bg-black/20 backdrop-blur-xl border-t border-slate-200/30">
                <h3 className="font-black text-sm sm:text-lg mb-2 text-white md:group-hover:text-slate-100 transition-colors duration-300 drop-shadow-lg">
                  {cards[3]?.title || "Specialty Pastas"}
                </h3>
                <p className="text-slate-100/90 text-xs sm:text-sm leading-relaxed font-medium">
                  {cards[3]?.subtitle || "Made to Impress"}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}